/* Formatting that depends on a setting rather than only on the value.

   `fmtMinOfDay` is the whole of it so far. It reads `S.clock.format`, which is
   why it is not in `core/time.js` — that file imports nothing and is worth
   keeping that way. Anything that formats by consulting state belongs here. */

import { S } from '../state/store.js';
import { pad } from '../core/time.js';

/** 870 → "2:30 pm", in whatever the clock is set to. */
export function fmtMinOfDay(n) {
  const h = Math.floor(n / 60), m = Math.round(n) % 60;
  if (S.clock.format === '24') return `${pad(h)}:${pad(m)}`;
  const ampm = h >= 12 ? 'pm' : 'am';
  const h12 = h % 12 === 0 ? 12 : h % 12;
  return `${h12}:${pad(m)}${ampm}`;
}
